import { HFBox, HFCheckbox } from '@hf/designSystem/v1';
import type { OmsLayoutColumn } from '@hf/sharedContract';

/** Columns stay in their current order. The modal lists them A–Z and only changes which ones show. */
export function ColumnVisibilityList({
  columns,
  label,
  onChange,
}: {
  columns: OmsLayoutColumn[];
  label: (id: string) => string;
  onChange: (next: OmsLayoutColumn[]) => void;
}) {
  const ordered = [...columns].sort((left, right) => label(left.id).localeCompare(label(right.id), undefined, { sensitivity: 'base' }));
  return (
    <HFBox
      component="ul"
      aria-label="Columns"
      sx={{ m: 0, p: 0, listStyle: 'none', display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 1 }}
    >
      {ordered.map((column) => {
        const toggle = (visible: boolean) => onChange(columns.map((item) => (item.id === column.id ? { ...item, visible } : item)));
        return (
          <HFBox
            component="li"
            key={column.id}
            onClick={() => toggle(!column.visible)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              minWidth: 0,
              px: 1,
              py: 1,
              borderRadius: 1,
              cursor: 'pointer',
              '&:hover': { bgcolor: 'action.hover' },
              '& .MuiFormControlLabel-root': { width: '100%', m: 0, pointerEvents: 'none' },
            }}
          >
            <HFCheckbox label={label(column.id)} checked={column.visible} onChange={(checked) => toggle(checked)} />
          </HFBox>
        );
      })}
    </HFBox>
  );
}
